var iCartTotal = 0;


window.onload = function() 
{
    $('.close-btn').on('click', function(e) { 
      e.preventDefault(); });
  var bonresetchange = false;
  var i = 0;
  var arrayCartItemsId = [];
  getCart();
  function getCart() 
  {
    $.ajax({
      type: 'GET', 
       url: '/cart.js',
       success: getCartList,
       error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    });
  }

  function getCartList(CartList)
  {
    var incoming = JSON.parse(CartList);
    var arrayCartItems = incoming.items;
    var arrayLength = arrayCartItems.length;

    if(arrayLength > 8)
    {
      var cartButtonContainer = document.getElementsByClassName("cartsidebarfooter")[0];
      cartButtonContainer.style = "position: fixed";
    }
    else
    {
      try
      {
        var cartButtonContainer = document.getElementsByClassName("cartsidebarfooter")[0];
        cartButtonContainer.style = "position: unset";
      }
      catch(e){}

    }
    for (var i = 0; i < arrayLength; i++) 
    {
      arrayCartItemsId.push(arrayCartItems[i].product_id);
    }
    
    if(iChanger == 0)
    {
      try
      {
        iChanger = 385;
        i = 385;
        bonresetchange = true;
        var emptyspan = document.createElement("span");
        shopGrid = document.getElementsByClassName("snize-search-results-content")[0];
        shopGrid.appendChild(emptyspan);
      
      }
      catch(e){}

    }
  }
  var iChanger = 385;
  var shopGrid =  document.getElementById("ProductGridContainer");
  if(shopGrid == "null" || shopGrid == null)
  {
    iChanger = 0;
    shopGrid =  document.getElementsByClassName("snize-search-results-content")[0];    
    iChanger = 0;
  }
 
  const config = { childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for(let mutation of mutationsList) 
    {

      if(bonresetchange)
      {
        iChanger = 385;
        i = 385;
        bonresetchange = false;
      }
      if(i == iChanger)
      {   

        i= 0;
        observer.disconnect();
        var priceElements = document.getElementsByClassName('snize-price-list');

        for (var k = 0; k < priceElements.length; k++) 
        {

          var strInt = priceElements[k].children[0].outerText.slice(1);
          var int50price = parseFloat(strInt);
          var intprice = parseFloat(strInt);
          intprice = intprice.toFixed(2);
          int50price = int50price;
          int50price = int50price.toFixed(2);
          strInt = "£";
          strInt = strInt.concat(intprice);

          var strIntNew = "£";
          strIntNew = strIntNew.concat(int50price);
          var PriceMaster = document.createElement('div')

          var spanOldPrice = document.createElement('span')
          spanOldPrice.classList.add("shop_item_price_discount");
          spanOldPrice.innerHTML = strInt;

          var spanNewPrice = document.createElement('span')
          spanNewPrice.innerHTML = strIntNew;


          PriceMaster.appendChild(spanNewPrice);
          priceElements[k].children[0].outerText = "";
          priceElements[k].append(PriceMaster);



        }


        var numItems = $('.snize-add-to-cart-button').length;

        if(numItems == 0)
        {
          $(".fa-bag-shopping").each(function() 
          {
            var strURLID = this.parentNode.parentNode.parentNode.parentNode.id;
            strURLID = strURLID.match(/\d+/)[0];
            strURLID = strURLID.replace(/\s/g, '');
            var found = arrayCartItemsId.indexOf(parseInt(strURLID));
            $(this).text("");
            $(this).removeClass("snize-add-to-cart-button");
            if(found !=-1)
            {
              $(this).removeClass("fa fa-bag-shopping");
              $(this).addClass("fa fa-remove");
              $(this).prop('title', 'Remove From Cart');
            } 
            else
            {
              $(this).addClass("fa fa-bag-shopping");
              $(this).prop('title', 'Add To Cart');
            }

          });
        }
        else
        {
          $(".snize-add-to-cart-button").each(function() 
          {
            var strURLID = this.parentNode.parentNode.parentNode.parentNode.id;
            strURLID = strURLID.match(/\d+/)[0];
            strURLID = strURLID.replace(/\s/g, '');

            var found = arrayCartItemsId.indexOf(parseInt(strURLID));
            
            $(this).text("");
            $(this).removeClass("snize-add-to-cart-button");
            if(found !=-1)
            {
              $(this).addClass("fa fa-remove");
              $(this).prop('title', 'Remove From Cart');
            } 
            else
            {
              $(this).addClass("fa fa-bag-shopping");
              $(this).prop('title', 'Add To Cart');
            }

          });
        }
        observer.observe(shopGrid, config);
      }
      i++;
    }
  };
  try
  {
    var observer = new MutationObserver(callback);
    observer.observe(shopGrid, config);
    var emptyspan = document.createElement("span");
    shopGrid.appendChild(emptyspan);
  }
  catch(e)
  {

  }

}


// Searchanise event for the autocomplete widget END

    var vid;
  document.addEventListener('click', function(e)
  {
    try
    {
      if(e.target.className.includes('fa-bag-shopping'))
      {
        e.preventDefault();
        
        var loadingSpinner = document.createElement("span");
  
        loadingSpinner.classList.add("loader");
        e.target.appendChild(loadingSpinner);
        e.target.classList.add('fa-loading-custom');
        e.target.classList.remove('fa-bag-shopping');
  
        var strURL = e.target.parentNode.href + ".json";
  
        vid = "";
        console.log(strURL);
        getItem();
        function getItem() 
        {
          $.ajax({
            type: 'GET', 
             url: strURL,
             success: getProduct,
             error: function(XMLHttpRequest, textStatus) {
              console.log(XMLHttpRequest, textStatus);
            }
          });
        }
  
       var items = {
            "id": 40755888685207,
            "quantity": 1
          }
        
        function addItem() {
          $.ajax({
             type: 'POST', 
             url: '/cart/add.js',
             dataType: 'json', 
             data:  items, 
             success: addToCartOk,
             error: function(XMLHttpRequest, textStatus) {
              loadingSpinner.remove();
              console.log(XMLHttpRequest, textStatus);
            }
          });
       }
      }
    }
    catch(e)
    {
      console.log("238");
    }

    try
    {
      if(e.target.className.includes('fa-remove'))
      {
        e.preventDefault();

        var loadingSpinner = document.createElement("span");

        loadingSpinner.classList.add("loader");
        e.target.appendChild(loadingSpinner);
        e.target.classList.add('fa-loading-custom');
        e.target.classList.remove('fa-remove');
        
        var strURL = e.target.parentNode.href + ".json";

        vid = "";
        var items = 
        {
          "id": 40755888685207,
          "quantity": 1
        };
        getItemRemove();
        function getItemRemove() 
        {
          $.ajax({
            type: 'GET', 
            url: strURL,
            success: removeItem,
            error: function(XMLHttpRequest, textStatus) {
              console.log(XMLHttpRequest, textStatus);
            }
          });
        }

      }
    }
    catch(e)
    {
      console.log("279");
    }

    function removeToCartOk() 
    { 
        getCart2();
        function getCart2() 
        {
          $.ajax({
            type: 'GET', 
             url: '/cart.js',
             success: getCartList2,
             error: function(XMLHttpRequest, textStatus) {
              console.log(XMLHttpRequest, textStatus);
            }
          });
        }
      
        function getCartList2(CartList)
        {
          iCartTotal = 0;
          var incoming = JSON.parse(CartList);
          var arrayCartItems = incoming.items;
          var arrayLength = arrayCartItems.length;
          for (var i = 0; i < arrayLength; i++) 
          {
            iCartTotal = iCartTotal + arrayCartItems[i].original_price;
          }
          

          var iCartTotalTemp  = iCartTotal/100;
          var cartLoyalty = document.getElementById('cartLoyaltyTotal');
          var loyaltyPrice = iCartTotalTemp * 0.25;
          loyaltyPrice = loyaltyPrice.toFixed(2);
          cartLoyalty.innerHTML = "LOYALTY: £" + loyaltyPrice + " OFF Your Next Order";

          var cartFreeShipping = document.getElementById('cartFreeShippingOff');
          var cartFreeShippingPrice = 20-iCartTotalTemp;

          // if(cartFreeShippingPrice > 0)
          // {
          //   cartFreeShippingPrice = cartFreeShippingPrice.toFixed(2);
          //   cartFreeShipping.style.background = "#ff8000";
          //   cartFreeShipping.innerHTML = "Get Free Shipping: Add £" + cartFreeShippingPrice;
          // }
          if(iCartTotalTemp < 0)
          {
            cartFreeShippingPrice = cartFreeShippingPrice.toFixed(2);
            cartFreeShipping.style.background = "#ff8000";
            cartFreeShipping.innerHTML = "Get Free Shipping: Add Item to Basket";
          }
          else
          {
            cartFreeShipping.style.background = "Green";
            cartFreeShipping.innerHTML = "You Have Earnt FREE Shipping";
          }

      
          var cart5OffCount = document.getElementById('cart5OffCount');
          var cart5OffCountPrice = 25-iCartTotalTemp;
          if(cart5OffCountPrice > 0)
          {
            cart5OffCountPrice = cart5OffCountPrice.toFixed(2);
            cart5OffCount.style.background = "#ff8000";
            cart5OffCount.innerHTML = "Get £5 OFF: ADD £" + cart5OffCountPrice;
          }
          else
          {
            cart5OffCount.style.background = "Green";
            cart5OffCount.innerHTML = "You Have Got £5 OFF Your Order";
          }
          
        
        }
       loadingSpinner.remove();
       e.target.classList.remove("fa-remove");
       e.target.classList.add("fa-bag-shopping");
       e.target.setAttribute('title', 'Add To Cart');
       jQuery.getJSON('/cart.js', function (cart, textStatus) 
       {
          //the cart info is in the callback. the item_count is available as part of the callback
          //below I set my cartcount div with the current cart item_count
          var carttext="("+cart.item_count +")";
          jQuery(".cart-count-bubble").text(carttext);
          jQuery(".count-cart-sidebar").text(carttext);

          if(cart.item_count == 0)
          {

            var emptycartitem  = document.createElement('div');
            emptycartitem.classList.add("cart-item-link"); 
            emptycartitem.innerHTML ='<div id="emptycartfiller" class="sidebar-cart-item"><p>Cart Is Empty</p></div>';
                var cartdiv = document.getElementsByClassName('preworn-flex-container')[0];
                cartdiv.appendChild(emptycartitem);
          }
         if(cart.item_count > 8)
          {
            var cartButtonContainer = document.getElementsByClassName("cartsidebarfooter")[0];
            cartButtonContainer.style = "position: fixed";
          }
          else
          {
            var cartButtonContainer = document.getElementsByClassName("cartsidebarfooter")[0];
            cartButtonContainer.style = "position: unset";
          }

        });
     } 

    function removeItem(product) 
    {
      console.log("329");
      vid = product.product.variants[0].id;
      var removedsidebaritem =  document.getElementById(vid);
      removedsidebaritem.parentNode.parentNode.remove();
      console.log(vid);
      items = {
        "id": vid,
        "quantity": 0
      }      
      $.ajax({
         type: 'POST', 
         url: '/cart/change.js',
         dataType: 'json', 
         data:  items, 
         success: removeToCartOk,
         error: function(XMLHttpRequest, textStatus) {
          loadingSpinner.remove();
          console.log(XMLHttpRequest, textStatus);
        }
      });
    }

    function getProduct(product) { 
      vid = product.product.variants[0].id;
      console.log(vid);
      items = {
        "id": vid,
        "quantity": 1
      }      
      addItem();
   } 

    
    function addToCartOk(product) { 
        getCart2();
        function getCart2() 
        {
          $.ajax({
            type: 'GET', 
             url: '/cart.js',
             success: getCartList2,
             error: function(XMLHttpRequest, textStatus) {
              console.log(XMLHttpRequest, textStatus);
            }
          });
        }
      
        function getCartList2(CartList)
        {

          iCartTotal = 0;
          var incoming = JSON.parse(CartList);
          var arrayCartItems = incoming.items;
          var arrayLength = arrayCartItems.length;
          for (var i = 0; i < arrayLength; i++) 
          {
            iCartTotal = iCartTotal + arrayCartItems[i].original_price;
          }
          loadingSpinner.remove();
      
          var emptycart =  document.getElementById("emptycartfiller");
            if (emptycart) {
                document.getElementById("emptycartfiller").remove();
            }
     
          e.target.classList.remove("fa-bag-shopping");
          e.target.classList.add("fa-remove");
    
          var cartitemlink = document.createElement('div');
          cartitemlink.classList.add("sidebar-cart-item");
          
         
         const price =  (product.original_price/100);
    
            function formatMoney(number) {
              number = number.toFixed(2);
              const valueArray = number.split(".");
                var strNumber = '<span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem; position: relative; margin-right: 0px;color: #000;" class="poundSignSide">£</span><span style="font-weight: bold; font-size: 3rem; position: relative; margin-right: 1px;color: #000;" class="poundActualSide">';
                strNumber = strNumber.concat(valueArray[0]);
                strNumber = strNumber.concat('</span> <span style="font-weight: bold; top: -0.6em !important; font-size: 1.5rem;margin-left: -2px; position: relative; margin-right: 0px;color: #000; class="poundActualSide">');
                strNumber = strNumber.concat(valueArray[1]);
                strNumber = strNumber.concat("</span>");
                return strNumber;
              }
              
                      
              
          cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ product.image 
          +'"><img class="sidebar-cart-img" src="' + product.image 
          +'" /></a><a class="cart-item-link"  href="'+ product.url 
          +'"><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +product.title 
          +'</p></span><div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
          +'</div><span style="margin-left: 5px; width: fit-content;  position: relative; top: -8px; background-color: green; color: white; padding: 2px 8px 3px 8px; font-size: 1.4rem; border-radius: 6px;">Last One</span></div></a><span class="close-btn" js-preworn-close-modal=""><svg id="'+ product.id +'"class="remove-item-sidebar" width="15" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg></span></div>';
    
          var iCartTotalTemp  = iCartTotal/100;
          var cartLoyalty = document.getElementById('cartLoyaltyTotal');
          var loyaltyPrice = iCartTotalTemp * 0.25;
          loyaltyPrice = loyaltyPrice.toFixed(2);
          cartLoyalty.innerHTML = "LOYALTY: £" + loyaltyPrice + " OFF Your Next Order";

          var cartFreeShipping = document.getElementById('cartFreeShippingOff');
          var cartFreeShippingPrice = 20-iCartTotalTemp;
          
          // if(cartFreeShippingPrice > 0)
          // {
          //   cartFreeShipping.style.background = "#ff8000";
          //   cartFreeShipping.innerHTML = "Get Free Shipping: Add £" + cartFreeShippingPrice;
          // }

          if(iCartTotalTemp < 0)
          {
            cartFreeShippingPrice = cartFreeShippingPrice.toFixed(2);
            cartFreeShipping.style.background = "#ff8000";
            cartFreeShipping.innerHTML = "Get Free Shipping: Add Item to Basket";
          }
          else
          {
            cartFreeShipping.style.background = "Green";
            cartFreeShipping.innerHTML = "You Have Earnt FREE Shipping";
          }

      
          var cart5OffCount = document.getElementById('cart5OffCount');
          var cart5OffCountPrice = 25-iCartTotalTemp;
          if(cart5OffCountPrice > 0)
          {
            cart5OffCount.style.background = "#ff8000";
            cart5OffCount.innerHTML = "Get £5 OFF: ADD £" + cart5OffCountPrice;
          }
          else
          {
            cart5OffCount.style.background = "Green";
            cart5OffCount.innerHTML = "You Have Got £5 OFF Your Order";
          }
          var cartSideBarPrice = document.getElementById('cartSideBarPrice');
              
          var priceHTML = formatMoney(iCartTotalTemp);
          cartSideBarPrice.innerHTML = priceHTML;
    
          var cartdiv = document.getElementsByClassName('preworn-flex-container')[0];
          cartdiv.appendChild(cartitemlink);
          
          console.log(document.getElementsByClassName('icon-cart-empty').length);
          if(document.getElementsByClassName('icon-cart-empty').length != 0)
          {
            var carticon = document.getElementsByClassName('icon-cart-empty')[0];
            carticon.classList.remove("icon-cart-empty");
            carticon.classList.add("icon-cart");
            var cartcountdiv  = document.createElement('div');
            cartcountdiv.classList.add("cart-count-bubble");
            cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            
            document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
          }
    
          e.target.setAttribute('title', 'Remove From Cart');
          jQuery.getJSON('/cart.js', function (cart, textStatus) {
            //the cart info is in the callback. the item_count is available as part of the callback
            //below I set my cartcount div with the current cart item_count
            var carttext="("+cart.item_count +")";
            jQuery(".cart-count-bubble").text(carttext);
            jQuery(".count-cart-sidebar").text(carttext);
          });
    
    
          var priceCookie = getCookieAnnouncment("priceCookie");
    
          function getCookieAnnouncment(name) 
          {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
          }
      
          if(priceCookie)
          {
    
              if(iCartTotal > 100 && iCartTotal < 2000)
              {
                // var freeShippingDiv = document.getElementById('freeshippingAlert');
                // freeShippingDiv.style = "display: flex";
                // var currentShiipingCost = document.getElementById('currentShiipingCost');
                // currentShiipingCost.innerHTML = "Spend £" + (Math.round(2000 - iCartTotal)/100).toFixed(2) + " more...";
                // setTimeout(function() {
                //   freeShippingDiv.style = "display: none";
                // }, 6000); // <-- time in milliseconds
      
              }
              setCookieAnnouncment("priceCookie", iCartTotal);
              function setCookieAnnouncment(name,value) 
              {
                  var expires = "";
                  var date = new Date();
                  date.setTime(date.getTime() + (604800*1000));
                  expires = "; expires=" + date.toUTCString();
                  document.cookie = name + "=" + value + ";" + expires + ";path=/";
              }
      
          }
          else
          {
            setCookieAnnouncment("priceCookie", iCartTotal);
            function setCookieAnnouncment(name,value) 
            {
                var expires = "";
                var date = new Date();
                date.setTime(date.getTime() + (604800*1000));
                expires = "; expires=" + date.toUTCString();
                document.cookie = name + "=" + value + ";" + expires + ";path=/";
            }
          }
        }


   } 

  });
  
  